import React from "react";
import Box from "@mui/material/Box";
import {Grid, Typography} from "@mui/material";
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import CardHeader from '@mui/material/CardHeader';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import {Link} from "react-router-dom";

const Merch = () => {
    return (
        <Box>
                <Box height={24}/>
            <Box sx={{marginTop: 4}}>
                <Typography variant="h4">Merch</Typography>
            </Box>
            <Box sx={{marginTop: 4}}>
                <Grid container spacing={{xs: 1, sm: 1, md: 2, lg: 3, xl: 4}}
                      columns={{xs: 2, sm: 2, md: 4, lg: 4, xl: 4}}>
                    <Grid item xs={1} sm={1} md={1} lg={1} xl={1}>
                        <Card>
                            <CardHeader
                                avatar={
                                    <Avatar sx={{bgcolor: "red"}} aria-label="recipe">
                                        GM
                                    </Avatar>
                                }
                                title="Guildmage black hoodie"
                                subheader="€39,00 EUR"
                            />
                            <CardMedia
                                component="img"
                                height="194"
                                image="https://cdn.shopify.com/s/files/1/0571/4568/8154/products/guildmage-legacy-black-hoodie-front.png?v=1666528154"
                                alt="Legacy Guildmage logo digital print black hoodie"
                            />
                            <CardContent>
                                <Typography variant="body2" color="text.secondary">Terry, brushed inside</Typography>
                                <Typography variant="body2" color="text.secondary">65% cotton, 35% polyester</Typography>
                                <Typography variant="body2" color="text.secondary">kangaroo pocket</Typography>
                                <Typography variant="body2" color="text.secondary">digital print</Typography>
                            </CardContent>
                            <CardActions>
                                <Button size="small" component="a"
                                        href="https://shop.guildmage.pro/products/legacy-guildmage-logo-digital-print-black-hoodie"
                                        target="_blank">Buy now</Button>
                            </CardActions>
                        </Card>
                    </Grid>
                    <Grid item xs={1} sm={1} md={1} lg={1} xl={1}>
                        <Card>
                            <CardHeader
                                avatar={
                                    <Avatar sx={{bgcolor: "red"}} aria-label="recipe">
                                        GM
                                    </Avatar>
                                }
                                title="Guildmage white hoodie"
                                subheader="€39,00 EUR"
                            />
                            <CardMedia
                                component="img"
                                height="194"
                                image="https://cdn.shopify.com/s/files/1/0571/4568/8154/products/guildmage-legacy-white-hoodie-front.png?v=1666528676"
                                alt="Legacy Guildmage logo digital print white hoodie"
                            />
                            <CardContent>
                            <Typography variant="body2" color="text.secondary">Terry, brushed inside</Typography>
                                <Typography variant="body2" color="text.secondary">65% cotton, 35% polyester</Typography>
                                <Typography variant="body2" color="text.secondary">kangaroo pocket</Typography>
                                <Typography variant="body2" color="text.secondary">digital print</Typography>
                            </CardContent>
                            <CardActions>
                                <Button size="small" component="a"
                                        href="https://shop.guildmage.pro/products/copy-of-black-lotus-playmat-24x40-inch-gold-border-limited-to-24-items"
                                        target="_blank">Buy now</Button>
                            </CardActions>
                        </Card>
                    </Grid>
                    <Grid item xs={1} sm={1} md={1} lg={1} xl={1}>
                        <Card>
                            <CardHeader
                                avatar={
                                    <Avatar sx={{bgcolor: "red"}} aria-label="recipe">
                                        GM
                                    </Avatar>
                                }
                                title="Black Lotus playmat"
                                subheader="€24,00 EUR"
                            />
                            <CardMedia
                                component="img"
                                height="194"
                                image="https://cdn.shopify.com/s/files/1/0571/4568/8154/products/blacklotus.png?v=1665148458"
                                alt="1/24 Black Lotus playmat 24x40 inch - limited to 24 items"
                            />
                            <CardContent>
                                <Typography variant="body2" color="text.secondary">Digital artwork</Typography>
                                <Typography variant="body2" color="text.secondary">Digital print</Typography>
                                <Typography variant="body2" color="text.secondary">Size: 24:40 inch</Typography>
                                <Typography variant="body2" color="text.secondary">Only 24 items available</Typography>
                            </CardContent>
                            <CardActions>
                                <Button size="small" component="a"
                                        href="https://shop.guildmage.pro/products/copy-of-black-lotus-playmat-24x40-inch-gold-border-limited-to-24-items"
                                        target="_blank">Buy now</Button>
                            </CardActions>
                        </Card>
                    </Grid>
                    <Grid item xs={1} sm={1} md={1} lg={1} xl={1}>
                        <Card>
                            <CardHeader
                                avatar={
                                    <Avatar sx={{bgcolor: "red"}} aria-label="recipe">
                                        GM
                                    </Avatar>
                                }
                                title="See more products"
                                subheader="Go to merch store"
                            />
                            <CardMedia
                                component="img"
                                height="194"
                                image="https://cdn.shopify.com/s/files/1/0571/4568/8154/files/hero_05b5b103-d95c-4b0f-a5d1-6016331cdae1.png?v=1665148811&width=1500"
                                alt="1/24 Black Lotus playmat 24x40 inch - limited to 24 items"
                            />
                            <CardContent>
                            <Typography variant="body2" color="text.secondary">Apparel</Typography>
                                <Typography variant="body2" color="text.secondary">Accessories</Typography>
                            <Typography variant="body2" color="text.secondary"><br /></Typography>
                                <Typography variant="body2" color="text.secondary"><br /></Typography>
                            </CardContent>
                            <CardActions>
                                <Button size="small" component="a"
                                        href="https://shop.guildmage.pro/"
                                        target="_blank">See more</Button>
                            </CardActions>
                        </Card>
                    </Grid>
                </Grid>

                <Box height={48}/>
            </Box>
        </Box>

    )
}

export default Merch;
